import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import LocaleProvider from "./utils/provider";
import App from "./App";

import reportWebVitals from "./secrets-web/src/reportWebVitals";

import i18n from './config/i18n';
import { I18nextProvider } from 'react-i18next';

import "./secrets-web/src/index.css";

const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(
  <React.Fragment>
    <Provider store={store}>
      <LocaleProvider>
        <BrowserRouter>
          <I18nextProvider i18n={i18n}>
            <App />
          </I18nextProvider>
        </BrowserRouter>
      </LocaleProvider>
    </Provider>
  </React.Fragment>
);

reportWebVitals();
